export interface PhotoCropButtonsProps {
  phone: boolean;
  buttonHeight: number;
  saveDisabled: boolean;
  onSave: () => void;
  onCancel: () => void;
}

/** Save photo and Cancel. On a phone they stack full width with Save on top. */
export function PhotoCropButtons({
  phone,
  buttonHeight,
  saveDisabled,
  onSave,
  onCancel,
}: PhotoCropButtonsProps) {
  const style = {
    height: buttonHeight,
    fontSize: 12.5,
    ...(phone ? { width: '100%', justifyContent: 'center' } : {}),
  } as const;
  const save = (
    <button
      key="save"
      type="button"
      className="nb-btn nb-btn-primary"
      disabled={saveDisabled}
      onClick={onSave}
      style={style}
    >
      Save photo
    </button>
  );
  const cancel = (
    <button
      key="cancel"
      type="button"
      className="nb-btn nb-btn-ghost"
      onClick={onCancel}
      style={style}
    >
      Cancel
    </button>
  );
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        flexDirection: phone ? 'column' : 'row',
        justifyContent: 'flex-end',
        alignItems: phone ? 'stretch' : 'center',
      }}
    >
      {phone ? [save, cancel] : [cancel, save]}
    </div>
  );
}
